import qs from 'querystring';

const getUrlParam = (key, href = window.location.href) => {
    const params = qs.parse(href.split('?')[1]);
    return key ? params[key] : params;
};

export default getUrlParam;
